import React, { Suspense } from 'react'

import { useLazyLoadQuery, graphql } from 'react-relay'

import { Button } from '../Button/Button'
import { Icon } from '../Icon'
import { UserPrimaryPhoto } from '../User/UserPrimaryPhoto'

import { Spinner } from '../Spinner'

import { DynamicIslandProfileButtonQuery } from './__generated__/DynamicIslandProfileButtonQuery.graphql'

export const DynamicIslandProfileButton = () => {
  return (
    <Suspense
      fallback={
        <Button
          key='profile'
          minHeight='$8'
          height='$8'
          width='$8'
          padding='$0'
          alignItems='center'
          justifyContent='center'
          secondary
        >
          <Spinner size='$5' color='$darkBlue9' />
        </Button>
      }
    >
      <DynamicIslandProfileButtonContent />
    </Suspense>
  )
}

const DynamicIslandProfileButtonContent = () => {
  const data = useLazyLoadQuery<DynamicIslandProfileButtonQuery>(
    graphql`
      query DynamicIslandProfileButtonQuery {
        viewer {
          slugId

          ...UserPrimaryPhotoNew_user
        }
      }
    `,
    {}
  )

  if (data.viewer) {
    return <UserPrimaryPhoto user={data.viewer} size='$8' thinShadow />
  }

  return (
    <Button
      key='profile'
      minHeight='$8'
      height='$8'
      width='$8'
      padding='$0'
      alignItems='center'
      justifyContent='center'
      secondary
    >
      <Icon name='person' />
    </Button>
  )
}
